// const BASE_URL = "https://localhost:7231/api/Education";


import { BASE_URL } from "../config";

// Education/educations
export const getAllEducation = async () => {
  try {
    const response = await fetch(`${BASE_URL}/Education/educations`);
    if (!response.ok) {
      throw new Error("Failed to fetch educations");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching educations:", error);
    throw error;
  }
};